import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Subject } from '../../subjects/subject';
import { UrlBuilder } from '../../core';
import { isEmpty, find } from 'lodash';
import { findSelectedSite } from '../../shared/route-helpers';

@Injectable()
export class SelectedSubjectResolver implements Resolve<Subject> {

    constructor(private urlBuilder: UrlBuilder) { }

    public resolve(route: ActivatedRouteSnapshot): any {
        const selectedSite = findSelectedSite(route);
        const subjects = route.parent.data['subjects'] as Subject[];
        const zcSubjectId: string = route.params['zcSubjectId'];

        if (isEmpty(subjects)) {
            this.urlBuilder.esa().site(selectedSite).subject().navigate();
            return false;
        }

        const selectedSubject = find(subjects, s => s.zcSubjectId === zcSubjectId);
        if (!selectedSubject) {
            this.urlBuilder.esa().site(selectedSite).subject({ zcSubjectId: subjects[0].zcSubjectId }).navigate();
            return false;
        }

        return selectedSubject;
    }
}